import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { FrappeApiHelper } from "@aht/frappe-client";

@Injectable({
  providedIn: "root",
})
export class SettingsService {
  constructor(private readonly helper: FrappeApiHelper) {}

  changePassword(oldPassword: string, newPassword: string): Observable<void> {
    return this.helper.call({
      method: "sar.controllers.settings_controller.change_password",
      type: "POST",
      body: {
        old_password: oldPassword,
        new_password: newPassword,
      },
    });
  }

  setNewPassword(key: string, newPassword: string): Observable<void> {
    return this.helper.call({
      method: "sar.controllers.settings_controller.set_new_password",
      type: "POST",
      body: {
        key: key,
        new_password: newPassword,
      },
    });
  }

  changeLanguage(language: string): Observable<void> {
    return this.helper.call({
      method: "sar.controllers.settings_controller.set_language",
      type: "POST",
      body: {
        language: language,
      },
    });
  }
}
